module.exports = __webpack_public_path__ + "static/img/corner-p.a9c5fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/corner-p.png
// module id = 10jm
// module chunks = 1